import React from 'react'
import clsx from 'clsx'
import { useIntl } from 'react-intl'
import Switch from '../../components/formControls/Switch'

const ZeroDayReminderSwitch = () => {
	const { formatMessage } = useIntl()
	return (
		<div
			className={clsx(
				'px-3 py-2 border rounded border-gray-300 !text-sm xl:!text-base'
			)}
		>
			<label
				htmlFor="zeroDayReminderEnabled"
				className="flex justify-between items-center gap-2 flex-shrink-0"
			>
				<span>
					{formatMessage({
						id: 'auto_task_reminders.on_due_date',
					})}
				</span>
				<Switch name="zeroDayReminderEnabled" />
			</label>
		</div>
	)
}
export default ZeroDayReminderSwitch
